import React, {PureComponent, createRef, useEffect} from "react";
import styles from "./css/FJBackgroundList.module.less";
import FJCoreUtil from "../../../core/util/FJCoreUtil";
import FJCustomScroll from "fj-components/FJCustomScroll";
import FJLocalStore from "../../../store/FJLocalStore";
import FJPageHeader from "fj-components/FJPageHeader";
import FJHorizontalScrollerIncludeArrowButton from "./FJHorizontalScrollerIncludeArrowButton";
import InlineSVG from "react-inlinesvg";
import rightSvg from "../../../icon/right.svg";
import FJResourceBackgroundCommon from 'fj-components/FJBackgroundColorContainer/FJResourceBackgroundCommon';
import FJResourceMediaCommon from 'fj-components/FJMediaContainer/FJResourceMediaCommon';
import FJMediaItemPlaceholder from "./FJMediaItemPlaceholder";
import FJViewConstant from "../../../constant/FJViewConstant";
import {FJImageRefresh} from "fj-components";
import FJLazyScroll from "./FJLazyScroll";
import FJPlaceholder from "./FJPlaceholder";

function RefreshItem(props) {
  const {onClick} = props;
  const refresh = createRef();
  useEffect(() => {
    refresh.current.show();
  });
  return (
    <div className={styles.refresh_box}>
      <FJImageRefresh ref={refresh} refreshCallback={onClick}/>
    </div>
  );
}

class FJBackgroundList extends PureComponent {

  _leftClick = (category, number) => {
    this[`_scroller${category}`].scrollLeft(this[`_scroller${category}`].getScrollLeft() - number)
    return (this[`_scroller${category}`].getScrollLeft() <= number || this[`_scroller${category}`].getScrollLeft() === 0);
  }

  _rightClick = (category, number) => {
    let scroll = this[`_scroller${category}`].getScroll();
    let scrollData = scroll.current.getValues();
    this[`_scroller${category}`].scrollLeft(this[`_scroller${category}`].getScrollLeft() + number)
    return (scrollData.scrollLeft + scrollData.clientWidth + number) >= scrollData.scrollWidth;
  }

  _getCollectionList = (activeList) => {
    let {seeMore, backgroundLists, seeAllText, classes, onListRefresh} = this.props;
    let items = [];
    let index = -1;
    for (let i in backgroundLists) {
      if (backgroundLists.hasOwnProperty(i)) {
        index++;
        let item = backgroundLists[i];
        let {category, list, hasStockVideoBox, status} = item;
        items.push(
          <div key={i} style={{width: '100%', height: '144px'}}>
            <FJPlaceholder active={index >= activeList[0] && index <= activeList[1]}>
              <FJPageHeader key={i}
                            title={FJLocalStore._(category)}
                            id={i}
                            onClick={() => {
                              seeMore(category)
                            }}
                            seeAllText={seeAllText}
                            classes={classes.pageHeaderClasses}
                            hasSeeAll={!!list.length}
                            hasIcon={false}
                            hasStockVideoBox={hasStockVideoBox}
                            stockVideoText={FJLocalStore._('stock-video')}
              >
                {status === FJViewConstant.STOCK_SEARCH_ERROR ? <RefreshItem onClick={() => {
                  onListRefresh(category)
                }}/> : this._renderList(item)}
              </FJPageHeader>
            </FJPlaceholder>
          </div>
        );
      }
    }
    return items;
  }

  _renderList = (item) => {

    let classes = {
      trackVertical: styles.displayNoneTrackVertical,
      trackHorizontal: styles.displayNoneTrackHorizontal,
      thumbVertical: '',
      thumbHorizontal: '',
      itemClasses: {
        resourceItemBox: '',
        resourceItemActive: '',
        inner: styles.inner_box
      }
    };

    return (
      <FJHorizontalScrollerIncludeArrowButton scrollerStyle={{width: "100%", height: '112px'}}
                                              hasShadow={false}
                                              rightClick={this._rightClick}
                                              leftClick={this._leftClick}
                                              category={item.category}
                                              length={10}
                                              moveDistance={420}
      >
        <FJCustomScroll classes={classes} ref={ref => {
          this[`_scroller${item.category}`] = ref
        }}>
          <div className={styles.cate_list}>
            {this._getItems(item)}
            {
              item.list.length > 3 && (
                <div className={styles.btn_box}>
                  <div className={styles.right_icon_box} onClick={() => {
                    this.props.seeMore(item.category)
                  }}>
                    <InlineSVG src={rightSvg}/>
                  </div>
                </div>
              )
            }
          </div>
        </FJCustomScroll>
      </FJHorizontalScrollerIncludeArrowButton>
    )
  }

  _getItems = (item) => {

    let {
      onAddClick,
      resourceViewInfo,
      classes,
      onMediaDrag,
      config,
      allTooltip,
      toggleTooltip,
      oneTooltip,
    } = this.props;


    let {
      width,
      height,
      space,
      marginBottom,
      marginTop,
      marginLeft
    } = resourceViewInfo;

    let {
      addIcon,
      addIconToolTip
    } = config;

    let items = [];
    let column = 15;
    let list = [...item.list];
    if (list.length === 0) {
      for (let i = 0; i < 10; i++) {
        list.push({id: i, status: 'placeholder'});
      }
    }
    list.forEach((data, index) => {
      if ((index + 1) <= column) {
        let subProps = {
          key: index,
          id: data.id,
          selectMedia: () => {
          },
          width: width,
          height: height,
          marginRight: (index + 1) % column === 0 ? 0 : space,
          marginBottom: marginBottom,
          marginTop: marginTop,
          type: data.type,
          onAddClick: onAddClick,
          classes: classes.itemClasses,
          addIcon: addIcon,
          onMediaDrag: onMediaDrag,
          addIconToolTip: addIconToolTip,
          allTooltip: allTooltip,
          toggleTooltip: toggleTooltip,
          oneTooltip: oneTooltip,
          marginLeft: marginLeft,
        };
        if (data.type === 'BACKGROUND') {
          items.push(
            <FJResourceBackgroundCommon {...{
              ...subProps,
              id: data.color,
              color: data.color,
            }}  />
          );
        } else {
          if (data.status === 'placeholder') {
            items.push(<FJMediaItemPlaceholder {...subProps} />);
          } else {
            items.push(
              <FJResourceMediaCommon {...{
                ...subProps,
                hasTime: data.type !== 'IMAGE',
                status: data.status,
                thumbnail: data.thumbnail,
                url: data.url,
                fromType: data.fromType,
                duration: data.duration,
                loadingAnimation: true
              }}  />
            );
          }

        }
      }
    })

    return items;
  }

  _onScroll = () => {
    FJCoreUtil.triggerBodyMousedown()
  };

  render() {

    let {
      isShow,
      classes = {}
    } = this.props

    return (
      <div className={styles.list_box} style={{display: isShow ? 'block' : 'none'}}>
        <FJLazyScroll classes={classes.scrollClasses}
                      itemHeight={144}
                      render={this._getCollectionList}
                      onScroll={this._onScroll}/>
      </div>
    )
  }

}

export default FJBackgroundList;
